import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { PackingSlipService } from 'common/data';

class PackingSlipStore extends BaseStore {
	constructor(rootStore) {
		super(new PackingSlipService(rootStore.app.baasic.apiClient));
	}

	@action
	async generatePdf(id, isManual) {
		const response = await this.service.generatePdf(id, isManual);
		this.response = response.data;
		return this.response;
	}
}

export default PackingSlipStore;
